module.exports = __webpack_public_path__ + "static/src/content/images/le romain.180c36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/le romain.png
// module id = 52Od
// module chunks = 0